import { isEqual } from 'lodash';
import { useRef } from 'react';

/**
 * Returns a referentially stable version of `value` that only changes identity
 * when its contents change (by deep equality).
 *
 * Useful for values derived on every render (e.g. `array.filter(...)`) that are
 * then passed to consumers which key behavior off reference identity — most
 * notably MUI's Autocomplete, which resets in-progress typing whenever its
 * `value` prop changes by reference. See T2-10778.
 */
export function useStableValue<T>(value: T): T {
  const ref = useRef(value);
  if (!isEqual(ref.current, value)) {
    ref.current = value;
  }
  return ref.current;
}
